import { render } from "./SeatItem.vue?vue&type=template&id=1136d672&scoped=true&ts=true"
import script from "./SeatItem.vue?vue&type=script&lang=ts"
export * from "./SeatItem.vue?vue&type=script&lang=ts"

import "./SeatItem.vue?vue&type=style&index=0&id=1136d672&scoped=true&lang=css"

import exportComponent from "/Users/lxb/kuaike/kunpeng-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1136d672"]])

export default __exports__